import ErrorPage from "../../assets/images/404_error_page.png";

const PageInProgress = () => {
  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      <div>
        <img src={ErrorPage} />
      </div>
    </div>
  );
};

export default PageInProgress;
